import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
  Box,
  Typography,
  Input,
  IconButton,
  Table,
  Button,
} from '@mui/joy';
import {Ban, Archive, ChevronLeft, ChevronRight, ArrowUp, ArrowDown, Ambulance, Helicopter, Backpack, BriefcaseMedical, Pencil } from 'lucide-react';
import ModaleMezzo from '../../components/ModaleMezzo';
import { authFetch } from '../../utils/authFetch';
import { canEditVehicles } from '../../utils/permissions';
import { useNavigate } from 'react-router-dom'; 

import { toast } from 'react-toastify';
import ModaleConferma from '../../components/ModaleConferma';

export default function Mezzi() {
  const [showModale, setShowModale] = useState(false);
  const navigate = useNavigate();


  const [Vehicles, setMezzi] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(1);
  const perPage = 20; //vehicles per page
  const [sortConfig, setSortConfig] = useState({ key: 'nome', direction: 'asc' });

  const selectedOrg = localStorage.getItem('selectedOrg'); //get id da storage
  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [vehicleToDelete, setvehicleToDelete] = useState(null);

  const ruoloLabels = {
    1: { icon: <Ambulance />, color: 'primary' },
    2: { icon: <BriefcaseMedical />, color: 'danger' },
    3: { icon: <BriefcaseMedical />, color: 'neutral' },
    4: { icon: <Helicopter />, color: 'danger' },
    5: { icon: <Backpack />, color: 'primary' },
  };

  // Memorizza fetchVehicles per non ricrearla ad ogni render
  const fetchVehicles = useCallback(async () => {
    if (!selectedOrg) return;
    try {
      const res = await authFetch(
        `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/vehicle/all`,
        {
          credentials: 'include',
        }
      );
      if (!res.ok) throw new Error('Errore fetch Risorse');
  
      const data = await res.json();
  
      if (Array.isArray(data)) {
        setMezzi(data);
      } else {
        console.warn('Risposta inattesa:', data);
        setMezzi([]);
        toast.error('Risposta inattesa dal server risorse', {
          position: 'top-right',
          autoClose: 3000,
        });
      }
    } catch (err) {
      console.error('Errore nel fetch risorse:', err);
      setMezzi([]);
      toast.error('Errore nel caricamento delle risorse', {
        position: 'top-right',
        autoClose: 3000,
      });
    }
  }, [selectedOrg]);
  
  const handleConfirmDelete = async () => {
    const vehicleId = vehicleToDelete?.id;
    if (!vehicleId) return;
  
    try {
      const res = await authFetch(
        `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/vehicle/${vehicleId}/status`,
        {
          method: 'PATCH',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ vehicle_id: vehicleId, status: 2 }),
        }
      );
      
 
      
      if (!res.ok) throw new Error('Errore nella modifica');
  
      toast.success('Stato del mezzo aggiornato con successo', { position: 'top-right', autoClose: 3000 });
      fetchVehicles();

    } catch (err) {
      console.error(err);
      toast.error('Errore nella modifica del mezzo', { position: 'top-right', autoClose: 3000 });
    } finally {
      setConfirmDeleteOpen(false);
      setvehicleToDelete(null);
    }
  };  

  const handleToggleStatus = async (vehicleId, vehicleStatus) => {
    const nuovoStatus = vehicleStatus === 1 ? 0 : 1;
    try {
      const res = await authFetch(
        `${process.env.REACT_APP_SERVER_HOST}/org/${selectedOrg}/vehicle/${vehicleId}/status`,
        {
          method: 'PATCH',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ vehicle_id: vehicleId, status: nuovoStatus }),
        }
      );
      
   
      if (!res.ok) throw new Error('Errore nella modifica');
  
      toast.success('Stato del mezzo aggiornato con successo', { position: 'top-right', autoClose: 3000 });
      fetchVehicles();

    } catch (err) {
      console.error(err);
      toast.error('Errore nella modifica del mezzo', { position: 'top-right', autoClose: 3000 });
    } 
  };

  useEffect(() => {
    fetchVehicles();
  }, [fetchVehicles]);

  const filteredVehicles = useMemo(() => {
    const lowerTerm = searchTerm.toLowerCase();
    return Vehicles.filter((u) =>
      u.name_vehicle.toLowerCase().includes(lowerTerm) ||
      u.code_vehicle.toLowerCase().includes(lowerTerm) ||
      u.category_name?.toLowerCase().includes(lowerTerm)
    );
  }, [searchTerm, Vehicles]);  

  const sortedVehicles = useMemo(() => {
    if (!sortConfig.key) return filteredVehicles;

    return [...filteredVehicles].sort((a, b) => {
      let valA = a[sortConfig.key];
      let valB = b[sortConfig.key];

      if (sortConfig.key === 'id') {
        valA = Number(valA);
        valB = Number(valB);
      } else {
        valA = valA?.toString().toLowerCase() || '';
        valB = valB?.toString().toLowerCase() || '';
      }

      if (valA < valB) return sortConfig.direction === 'asc' ? -1 : 1;
      if (valA > valB) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [filteredVehicles, sortConfig]);

  const paginatedVehicles = useMemo(() => {
    const start = (page - 1) * perPage;
    return sortedVehicles.slice(start, start + perPage);
  }, [page, sortedVehicles]);

  const totalPages = Math.ceil(sortedVehicles.length / perPage);

  const handleSort = (key) => {
    setPage(1);
    setSortConfig((current) => {
      if (current.key === key) {
        return {
          key,
          direction: current.direction === 'asc' ? 'desc' : 'asc',
        };
      }
      return { key, direction: 'asc' };
    });
  };

  const SortIcon = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <ArrowDown size={14} color="#bbb" />;
    }
    return sortConfig.direction === 'asc' ? (
      <ArrowUp size={14} color="black" />
    ) : (
      <ArrowDown size={14} color="black" />
    );
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    return date.toLocaleDateString('it-IT');
  };
  

  return ( 
        <Box>
          <Typography level="h3" mb={2}>
            Risorse
          </Typography>

          <Box mb={2} display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={2}>
            <Box display="flex" alignItems="center" gap={2}>
              <Input
                placeholder="Cerca risorsa..."
                value={searchTerm}
                onChange={(e) => {
                  setSearchTerm(e.target.value);
                  setPage(1);
                }}
                sx={{ maxWidth: 300 }}
              />
              <Typography level="body-sm" color="neutral">
                {sortedVehicles.length} record trovati
              </Typography>
            </Box>
            {canEditVehicles() && (
              <Button
                variant="solid"
                color="primary"
                onClick={() => setShowModale(true)}
              >
                + Aggiungi Risorsa
              </Button>
            )}
          </Box>

          <Box
            sx={{
              borderRadius: 'lg',
              overflow: 'hidden',
              border: '1px solid',
              borderColor: 'neutral.outlinedBorder',
            }}
          >
          <Table
            size="sm"
            sx={{
              minWidth: { xs: '100%', sm: 500 },
              borderRadius: 0,
              tableLayout: 'auto',
              '& thead th': {
                bgcolor: 'neutral.softBg',
                textAlign: 'left',
                px: { xs: 1, sm: 2 },
                py: { xs: 0.5, sm: 1 },
                fontSize: { xs: 'xs', sm: 'sm' },
                lineHeight: 1.2,
                whiteSpace: 'nowrap',
              },
              '& tbody td': {
                px: { xs: 1, sm: 2 },
                py: { xs: 0.5, sm: 1 },
                fontSize: { xs: 'sm', sm: 'md' },
                lineHeight: 1.2,
                wordBreak: 'break-word',
              },
              '& tbody tr:hover': {
                bgcolor: 'neutral.plainHoverBg',
              },
            }}
          >
              <thead>
                <tr>
                  <th onClick={() => handleSort('name_vehicle')} style={{ cursor: 'pointer' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      Nome
                      <SortIcon columnKey="name_vehicle" />
                    </Box>
                  </th>
                  <th onClick={() => handleSort('type_vehicle')} style={{ cursor: 'pointer' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      Tipo
                      <SortIcon columnKey="type_vehicle" />
                    </Box>
                  </th>
                  <th onClick={() => handleSort('category_id')} style={{ cursor: 'pointer' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      Categoria
                      <SortIcon columnKey="category_id" />
                    </Box>
                  </th>
                  <th onClick={() => handleSort('code_vehicle')} style={{ cursor: 'pointer' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      Codice
                      <SortIcon columnKey="code_vehicle" />
                    </Box>
                  </th>
                  <th onClick={() => handleSort('last_check')} style={{ cursor: 'pointer' }}>
                    <Box display="flex" alignItems="center" gap={1}>
                      Ultimo Controllo
                      <SortIcon columnKey="last_check" />
                    </Box>
                  </th>
                  {canEditVehicles() && (
                    <th style={{ textAlign: 'center', width: 80 }}>Azioni</th>
                  )}
                </tr>
              </thead>
              <tbody>
                {paginatedVehicles.length > 0 ? (
                  paginatedVehicles.map((vehicle) => {
                    const ruolo = ruoloLabels[vehicle.type_vehicle];
                    const isArchived = vehicle.status === 2;

                    return (
                      <tr key={vehicle.id}>
                        <td>
                          <Box display="flex" alignItems="center" gap={1}>
                            <Box
                              sx={{
                                width: 10,
                                height: 10,
                                borderRadius: '50%',
                                bgcolor:
                                  vehicle.status === 1
                                    ? 'success.solidBg' 
                                    : vehicle.status === 0
                                    ? 'danger.solidBg' 
                                    : 'neutral.outlinedDisabledColor',
                              }}
                            />
                            <span>{vehicle.name_vehicle}</span>
                          </Box>
                        </td>

                        <td>
                          {ruolo && (
                            <Box
                              component="span"
                              sx={{
                                display: 'inline-block',
                                px: 1.5,
                                py: 0.5,
                                borderRadius: 'xl',
                                fontSize: 'sm',
                                fontWeight: 'md',
                                color: `${ruolo.color}.solidBg`,
                              }}
                            >
                              {ruolo.icon}
                            </Box>
                          )}
                        </td>
                        <td>{vehicle.category_name}</td>
                        <td>{vehicle.code_vehicle}</td>
                        <td>{formatDate(vehicle.last_check)}</td>
                  
                        {canEditVehicles() && !isArchived && (
                          <td style={{ textAlign: 'center' }}>
                            <Box display="flex" justifyContent="center" gap={1}>
                              <IconButton
                                size="sm"
                                variant="soft"
                                color="primary"
                                onClick={() => navigate(`/risorse/${vehicle.id}`)}
                              >
                                <Pencil size={16} />
                              </IconButton>

                              <IconButton
                                size="sm"
                                variant="soft"
                                color={vehicle.status === 1 ? 'danger' : 'success'}
                                onClick={() => handleToggleStatus(vehicle.id, vehicle.status)}
                              >
                                <Ban size={16} />
                              </IconButton>

                              <IconButton
                                size="sm"
                                variant="soft"
                                color="danger"
                                onClick={() => {
                                  setvehicleToDelete(vehicle);
                                  setConfirmDeleteOpen(true);
                                }}
                              >
                                <Archive size={16} />
                              </IconButton>
                            </Box>
                        </td>
                        )}
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan={5} style={{ textAlign: 'center', padding: '12px' }}>
                      Nessuna risorsa trovata.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </Box>

          {totalPages > 1 && (
            <Box mt={2} display="flex" justifyContent="space-between" alignItems="center">
              <Button
                size="sm"
                variant="outlined"
                disabled={page === 1}
                onClick={() => setPage((p) => p - 1)}
                startDecorator={<ChevronLeft size={14} />}
              >
                Precedente
              </Button>

              <Typography level="body-sm">
                Pagina {page} di {totalPages}
              </Typography>

              <Button
                size="sm"
                variant="outlined"
                disabled={page === totalPages}
                onClick={() => setPage((p) => p + 1)}
                endDecorator={<ChevronRight size={14} />}
              >
                Successiva
              </Button>
            </Box>
          )}

      <ModaleMezzo
        open={showModale}
        onClose={() => setShowModale(false)}
        onSuccess={() => {
          fetchVehicles();
          setShowModale(false);
          toast.success('Mezzo aggiunto/modificato con successo', {
            position: 'top-right',
            autoClose: 3000,
          });
        }}
      />
      <ModaleConferma
        open={confirmDeleteOpen}
        onClose={() => setConfirmDeleteOpen(false)}
        onConfirm={handleConfirmDelete}
        title="Conferma archiviazione"
        message={<>
          Sei sicuro di voler archiviare {vehicleToDelete?.code_vehicle || 'questo mezzo'}?<br />
          Non sarà più possibile ripristinarlo
        </>}
      />
    </Box>
  );
}
